import React, { Component } from 'react'
import { FormControl, FormHelperText } from 'material-ui/Form'
import HideIcon from 'material-ui-icons/Visibility'
import Input, { InputLabel, InputAdornment } from 'material-ui/Input'
import PropTypes from 'prop-types'
import ShowIcon from 'material-ui-icons/VisibilityOff'
import withStyles from 'material-ui/styles/withStyles'
import { IconButton } from 'material-ui';

const PROP_TYPES = {
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  preserveReduxFormValueOnToggle: PropTypes.func.isRequired,
  value: PropTypes.string
}

const styles = theme => ({
  fieldContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column"
  },
  inputField: {
    display: "flex"
  }
})


class FormPasswordToggleField extends Component {

  // Uses local state instead of redux pattern, since the logic is purely presentational;
  // only this component needs to know whether the password is visible.
  constructor(props) {
    super(props)
    this.state = { isVisible: false }
  }

  togglePasswordVisibility() {
    this.setState({ isVisible: !this.state.isVisible })
  }

  render() {
    const {
      classes,
      disabled,
      helperText,
      input,
      label,
      meta: {
        touched,
        error,
        visited
      },
      preserveReduxFormValueOnToggle
    } = this.props

    return (
      <div className={classes.fieldContainer}>
        <FormControl fullWidth={true} disabled={disabled} error={error && (touched || visited)}>
          <InputLabel htmlFor={input.name}>{label}</InputLabel>
          <Input
            id={input.name}
            className={classes.inputField}
            {...input}
            onFocus={input.onFocus}
            onBlur={() => {
              preserveReduxFormValueOnToggle(input.name, input.value)
              input.onBlur(input.value)
            }}
            type={this.state.isVisible ? "text" : "password"}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="Toggle Password Visibility"
                  onClick={() => this.togglePasswordVisibility()}
                  onBlur={() => {
                    preserveReduxFormValueOnToggle(input.name, input.value)
                    // input.onBlur(input.values)
                  }}>
                  {this.state.isVisible ? <HideIcon /> : <ShowIcon />}
                </IconButton>
              </InputAdornment>
            } />
          <FormHelperText>{error && (touched || visited) ? error : helperText}</FormHelperText>
        </FormControl>
      </div>
    )
  }
}

FormPasswordToggleField.propTypes = PROP_TYPES

export default withStyles(styles)(FormPasswordToggleField)